import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CheckoutValidationErrorComponent } from '../../../checkout-validation-error';
import { DeliveryActiveAddressComponent } from './delivery-active-address';
import { DeliveryAddAddressComponent } from './delivery-add-address';
import { DeliveryAddressBlockServiceComponent, DeliveryState } from './delivery-address-block-component.service';

@Component({
  selector: 'sd-delivery-address-block',
  imports: [DeliveryAddAddressComponent, DeliveryActiveAddressComponent, CheckoutValidationErrorComponent],
  templateUrl: './delivery-address-block.component.html',
  styleUrls: ['./delivery-address-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DeliveryAddressBlockServiceComponent],
})
export class DeliveryAddressBlockComponent {
  private deliveryStateService = inject(DeliveryAddressBlockServiceComponent);

  protected readonly state = this.deliveryStateService.state;
  protected readonly deliveryState = DeliveryState;
}
